export async function urlToFile(url, filename) {
  try {
    // Fazendo a requisição da imagem
    const response = await fetch(url);
    const blob = await response.blob();

    // Criando um objeto File a partir do blob
    const file = new File([blob], filename, { type: blob.type });

    return file;
  } catch (error) {
    console.log("ERRO NA TENTATIVA DE ACESSAR UM LINK ", error);
    return null;
  }
}
